export default {
    path: 'page',
    component: () => import('../Page.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách thân trang',
            component: () => import('../../table/Table.vue'),
        },
        {
            path: 'desktop/:id',
            name: 'Thân trang cho máy tính',
            component: () => import('../../cu/CU.vue'),
        },
        {
            path: 'mobile/:id',
            name: 'Thân trang cho di động',
            component: () => import('../../cu/CU.vue'),
        },
    ]
};